import { render, staticRenderFns } from "./PeriodAmount.vue?vue&type=template&id=58ce6ab9&scoped=true&"
import script from "./PeriodAmount.vue?vue&type=script&lang=js&"
export * from "./PeriodAmount.vue?vue&type=script&lang=js&"
import style0 from "./PeriodAmount.vue?vue&type=style&index=0&id=58ce6ab9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ce6ab9",
  null
  
)

export default component.exports